<template>
  <div id="wrapper">
    <div id="contents" class="nofFoundArea">
      <h1>
        <img src="/images/404/text_404.png" alt="404 NOTFOUND" width="500" />
      </h1>
      <div class="textArea">
        <p class="text1">お探しのページは見つかりませんでした。</p>
        <p class="text2">
          申し訳ありません。<br class="sp" />
          削除、または掲載終了した可能性があります。
        </p>
      </div>

      <div class="linkArea">
        <div class="contents">
          <h2>
            海外旅行・国内旅行なら<br class="sp" />旅工房へお任せください！
          </h2>
          <ul>
            <li><a href="/">旅工房TOP</a></li>
            <li><a href="/tour/">ツアー検索</a></li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import '@/assets/css/notfound.scss'
export default {
  name: 'NotFound',
}
</script>
